module.exports = __webpack_public_path__ + "static/media/8.fc787727.png";